/// <amd-module name="Reporting/Visuals/LayoutComponents/Widgets/IDataManager" />
import { LayoutState } from "Widgets/LayoutState";
import { IDemandHandler } from "./Demands/IDemandHandler";

/**
 * Responsibility: Issues the lowest cost set of queries to satisfy a set of demands, and packs the Result into a LayoutState for use by the view's render-side implementation.
 * In particular, implementations of this interface are responsible for heuristically issuing the the lowest cost set of query implementations, based on the set of demands issued to it.
 * E.g. for a scalar-only demand, a low cost end-state query of a single value is optimal, where a scalar and chart scenario can be optimally be handled by post-processing Result from a single trend query, rather than issuing both a trend and scalar query to answer those questions.
 */
export interface IDataManager extends IDemandHandler {
    /**
     * Provides initial state object associated with demanded data shape.
     */
    getInitialState(): LayoutState;

    /**
     * Provides a promise for filling in actual demanded data from relevant storage.
     */
    getData(): Promise<LayoutState>;
}
